import React from 'react'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import { toggleContent } from 'front-end-core/services/StateService'
import { dismissPopover } from 'services/OverlayService'
import { pushEvent } from 'services/AnalyticsService'

const Selector = ({
  ids,
  selected,
  'data-help-item': dataHelpItem,
  'data-help-position': dataHelpPosition,
  'data-event-category': dataEventCategory,
  'data-event-action': dataEventAction,
  'data-event-label': dataEventLabel
}) => (selected === undefined)
  ? null
  : (
    <a
      href={null}
      className='mh2 pointer'
      onClick={(e) => {
        dismissPopover(e.target)
        e.preventDefault()
        e.stopPropagation()
        toggleContent(selected ? 0 : 1, 'precedents', ids)
        pushEvent({ category: dataEventCategory, action: dataEventAction, label: dataEventLabel })
      }}
      data-help-item={dataHelpItem}
      data-help-position={dataHelpPosition}
    >
      {selected ? <CheckBoxIcon className='teal w6' /> : <CheckBoxOutlineBlankIcon className='black w6' />}
    </a>
    )

export default Selector
